(function(APP, $, window, document) {
	'use strict';

	var $menu_btn = $('.js-menu-btn');
	var $menu_item_primary = $('.menu__item--primary');
	var $menu_link_primary_has_submenu = $('.menu__link--primary--has-submenu');
	var $submenu_back = $('.submenu-back');
	var $menu_list_sub_menu = $('.menu__list--sub-menu');
	var $menu_link_sub = $('.menu__link--sub');
	var $menu_list_hover_desktop = $('.menu__list--hover-desktop');
	var $search_desktop_btn = $('.js-search-desktop-btn');
	var $account_btn = $('.js-account-btn');
	var $login_form_username = $('#loginform .login-username');
	var $login_form_password = $('#loginform .login-password');
	var $login_form_remember = $('#loginform .login-remember');

	function Menu(options) {
		if (!(this instanceof Menu)) return new Menu(options);

		$menu_btn.on('click', function() {
			APP.$html.toggleClass('menu-is-open');
			APP.$html.removeClass('sub-menu-is-open');
			APP.$html.removeClass('account-is-open');
			$menu_item_primary.removeClass('sub-menu-is-open');
		});

		$menu_link_primary_has_submenu.on('click', function(event) {
			event.preventDefault();

			APP.$html.toggleClass('sub-menu-is-open');
			$(this).parent().toggleClass('is-open');

			var item_index = $(this).attr('data-item');

			$menu_list_sub_menu.not('[data-item="'+item_index+'"]').removeClass('is-open');

			if (item_index) {
				$menu_list_sub_menu.filter('[data-item="'+item_index+'"]').toggleClass('is-open');
			}

			return false;
		});

		$submenu_back.on('click', function(event) {
			event.preventDefault();

			APP.$html.removeClass('sub-menu-is-open');
			$menu_item_primary.removeClass('is-open');

			setTimeout(function() {
				$menu_list_sub_menu.removeClass('is-open');
			}, 200);

			return false;
		});

		$menu_link_sub.on('mouseenter', function() {
			var size = this.getBoundingClientRect();
			var index = $(this).parent().index() - 3;

			$menu_list_hover_desktop.css({
				transform: 'translateX('+(100 * index)+'%)',
				height: size.height,
			});
		});

		$search_desktop_btn.on('click', function() {
			APP.$html.toggleClass('search-desktop-is-open');
		});

		$account_btn.on('click', function() {
			APP.$html.toggleClass('account-is-open');
		});

		$('.js-account').on('click', function(e) {
			e.preventDefault();
			APP.$html.toggleClass('account-is-open');
		})

		// Ajoute les placeholder sur le formulaire de connexion
		$login_form_username.find('.input').attr('placeholder', $login_form_username.find('label').text());
		$login_form_password.find('.input').attr('placeholder', $login_form_password.find('label').text());

		// Met en place les class sur la checkbox sur le formulaire de connexion
		$login_form_remember.find('label').addClass('field-choice field-choice--checkbox');
		$('<span class="field-choice__fake-input"></span>').insertAfter($login_form_remember.find('input'));

		return this;
	}

	// Register prototyp methods
	// Menu.prototype = $.extend(true, Menu.prototype, {
	// 	init: init,
	// });

	$(window).on('load', function() {
		APP.store.menu = new Menu();
	});

})(APP, jQuery, window, document);
